import React, { useCallback, useEffect, useState } from "react";
import Layout from "../../hocs/Layout";
import { loadStripe } from "@stripe/stripe-js";
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";
import { connect } from "react-redux";
import { get_items, get_total } from "../../redux/actions/cart";
import { Helmet } from "react-helmet";

// CLAVE PÚBLICA de Stripe (pk_...)
const stripePromise = loadStripe(
  "pk_test_51NNdUvJtjUu1pxJYVOf8uFLYJrs4RvMIEP6AbPCX3oTdlENUeIY8mCBSSCiQsMSrnpEuspz2Ivd1SBZdkuspxUgi00BGyBnLzs",
);

function Checkout({ items, get_items, get_total }) {
  const [cartLoaded, setCartLoaded] = useState(false);

  useEffect(() => {
    get_items();
    get_total();
  }, []);

  useEffect(() => {
    if (items && items.length > 0) {
      setCartLoaded(true);
    }
  }, [items]);

  const showItems = () =>
    items.map((item) => (
      <div key={item.product.id} className="mb-2">
        {item.product.name} x {item.count}
      </div>
    ));

  // Construye el array para enviar al backend, incluyendo el id del producto
  const buildCart = () => {
    return items.map((i) => ({
      product: {
        id: i.product.id, // se pasa el id del producto
        name: i.product.name,
        price: i.product.price,
      },
      count: i.count,
    }));
  };

  // Función que Stripe llamará para obtener el client_secret
  const fetchClientSecret = useCallback(async () => {
    const cartData = buildCart();
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}/api/payment/embedded-checkout/`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: cartData,
        }),
      },
    );

    const data = await res.json();
    if (!res.ok) {
      console.error(data.error || "Error al crear la sesión de pago");
      return null;
    }
    return data.clientSecret; // Devuelve el clientSecret
  }, [items]);

  // Opciones para EmbeddedCheckoutProvider
  const options = { fetchClientSecret };

  // Metadatos dinámicos basados en el primer producto del carrito
  const firstProduct = items && items.length > 0 ? items[0].product : null;

  return (
    <Layout products={true}>
      <Helmet>
        <title>Histori AI - Checkout</title>
        <meta
          name="description"
          content="Descubre ropa vintage de alta calidad en Histori.ai. Encuentra lo que buscas entre nuestras diversas categorías y tallas."
        />

        <meta
          name="keywords"
          content="tienda, ropa, vintage, retro, calidad, categorías, tallas"
        />

        {/* Open Graph para Facebook y otras redes */}
        <meta
          property="og:title"
          content={`Histori.ai - ${
            firstProduct ? firstProduct.name : "Ropa Retro de Calidad"
          }`}
        />

        <meta
          property="og:description"
          content={`Compra ${
            firstProduct ? firstProduct.name : "ropa vintage de alta calidad"
          } en Histori.ai. Encuentra lo que buscas entre nuestras diversas categorías y tallas.`}
        />

        <meta
          property="og:image"
          content="https://histori.ai/path/a/tu-imagen.jpg"
        />

        <meta property="og:url" content="https://histori.ai" />

        <meta property="og:type" content="website" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />

        <meta
          name="twitter:title"
          content={`Histori.ai - ${
            firstProduct ? firstProduct.name : "Ropa Retro de Calidad"
          }`}
        />

        <meta
          name="twitter:description"
          content={`Compra ${
            firstProduct ? firstProduct.name : "ropa vintage de alta calidad"
          } en Histori.ai. ¡Explora nuestras categorías y encuentra el look perfecto!`}
        />

        <meta
          name="twitter:image"
          content="https://histori.ai/path/a/tu-imagen.jpg"
        />
      </Helmet>
      {/* Fondo con gradiente verde → blanco, y altura mínima full-screen */}
      <div className="bg-white min-h-screen py-8">
        {/* Contenedor centrado */}
        <div className="max-w-6xl mx-auto px-4">
          <h1 className="text-3xl font-bold mb-8">Checkout</h1>
          {cartLoaded && (
            <div className="">
              <EmbeddedCheckoutProvider
                stripe={stripePromise}
                options={options}
              >
                <EmbeddedCheckout />
              </EmbeddedCheckoutProvider>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
}

const mapStateToProps = (state) => ({
  items: state.Cart.items,
});

export default connect(mapStateToProps, {
  get_items,
  get_total,
})(Checkout);
